import { render, staticRenderFns } from "./DepositFundsModal.vue?vue&type=template&id=59de44d8"
import script from "./DepositFundsModal.vue?vue&type=script&lang=js"
export * from "./DepositFundsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports